import chatRoutes from './modules/chat';

const routes = [...chatRoutes];

export default routes;
